/**
 * Submit a form element
 * @example
	$_GP.ajaxSubmit('#form', {
		url: 'url/to/endpoint',
		data: '&dataNotInSerialize=12345',
		formReset: false,
		done: function(resp) {
			// request succeded and resp.success === true
		},
		$ajax: function($elm, call) {
			// $elm = $('#form')
			// call = $.ajax request
		}
	});
 * @param {string|jQuery} elm - form element
 * @param {object} opt - options, $_GP.ajaxSubmitInner options
 * @returns {undefined}
 * @requires $_GP.ajaxSubmitInner
 */
$_GP.ajaxSubmit = function(elm, opt) {
	const submit = function(ev) {
		ev.preventDefault();

		$_GP.ajaxSubmitInner(elm, opt);

		return false;
	};

	$(elm).on('submit', submit);
};
